import { render, staticRenderFns } from "./ItineraryModulePlaceholder.vue?vue&type=template&id=fd1f101e&scoped=true&"
import script from "./ItineraryModulePlaceholder.vue?vue&type=script&lang=js&"
export * from "./ItineraryModulePlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryModulePlaceholder.vue?vue&type=style&index=0&id=fd1f101e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1f101e",
  null
  
)

export default component.exports